import { Modal as ModalModule, Utils } from 'common';
import React, { useContext } from 'react';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Session, Util, BillingPlans } = Utils;
const { prettyPrintPlan } = BillingPlans;

const GBBPlanChangeModal = ({ modalId, data }) => {
	const {
		newPlanPrice,
		newPlanName,
		sku,
		currentPlanSku,
		onGBBChangePlan,
		currentPlanPrice,
	} = data;
	const { BillingDayOfMonth } = Session.getInternalAccountInfo();
	const { closeModal } = useContext(ModalContext);

	let isUpgrade = false;

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Confirm',
		onClick: () => {
			onGBBChangePlan(sku, currentPlanSku, isUpgrade);

			// close the modal
			closeModal(modalId, ModalButtonActionType.Ok);
		},
		dataqa: 'gbb-plan-change-confirm-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Cancel',
		dataqa: 'gbb-plan-change-cancel-button',
	};

	const getUpgradeModal = () => (
		<Modal
			modalId={modalId}
			className="account-change-plan gbb-plan-change-modal"
			header={`Change Plan to ${prettyPrintPlan(newPlanName)}`}
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
		>
			<div className="body">
				<p className="section1">
					Once confirmed, you will have access to your new plan features in just
					a few minutes.
				</p>
				<p className="section2">
					Your invoice for this billing cycle on{' '}
					{Util.getBillingDate(BillingDayOfMonth)} will include a prorated
					amount for your new plan, based on the number of days remaining in the
					billing cycle.
				</p>
			</div>
		</Modal>
	);

	const getDowngradeModal = () => {
		const billingDate = Util.getBillingDate(BillingDayOfMonth);
		const nextDayBillingDate = Util.getNextDay(billingDate);

		return (
			<Modal
				modalId={modalId}
				className="account-change-plan gbb-plan-change-modal"
				header={`Change Plan to ${prettyPrintPlan(newPlanName)}`}
				primaryButton={primaryButton}
				secondaryButton={secondaryButton}
			>
				<div className="body">
					<p className="section1">
						Once confirmed, your new plan will start on the first day of your
						next billing cycle {nextDayBillingDate}.
					</p>
					<p className="section2">
						Your account will remain on your prior plan, with the same features
						and plan fee until this billing cycle ends on {billingDate}.
					</p>
				</div>
			</Modal>
		);
	};

	const getPlanChangeModal = () => {
		if (currentPlanPrice <= newPlanPrice) {
			isUpgrade = true;
			return getUpgradeModal();
		} else {
			isUpgrade = false;
			return getDowngradeModal();
		}
	};

	return getPlanChangeModal();
};

export default GBBPlanChangeModal;
